import { Outlet, Navigate } from '@/util/react-router-dom';
import { useCurrentUser } from '@/contexts/current-user-context';
import { SurrogateI18nProvider } from '@/contexts/i18n-context';
import { isUserLoggedIn } from '@/util/helpers';

export function PrivateOutlet() {
  const { user } = useCurrentUser();

  if (!isUserLoggedIn(user)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <SurrogateI18nProvider source="patient">
      <Outlet />
    </SurrogateI18nProvider>
  );
}
